'use strict';
Object.defineProperty(exports, Symbol.toStringTag, {
    value: 'Module'
});
function at(arr, indices) {
    var result = new Array(indices.length);
    var length = arr.length;
    for(var i = 0; i < indices.length; i++){
        var index = indices[i];
        index = Number.isInteger(index) ? index : Math.trunc(index) || 0;
        if (index < 0) {
            index += length;
        }
        result[i] = arr[index];
    }
    return result;
}
exports.at = at;
